import type { EventCategory } from './base';

export const MenuEvents = {
  CUSTOMER_WORKSPACE_CONFIGURED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      canteenId: '' as string,
      companyCount: 0 as number,
      canteenCount: 0 as number,
      hasInvitedEmployees: false as boolean,
    },
  },
  CUSTOMER_MENU_CYCLE_STARTED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekId: '' as string,
      weekStartDate: '' as string,
      draftItemCount: 0 as number,
      canteenId: '' as string,
      createdByRole: '' as string,
      isFirstMenuForTenant: false as boolean,
    },
  },
  CUSTOMER_MENU_PUBLISHED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekIds: [] as string[],
      weekStartDate: '' as string,
      canteenIds: [] as string[],
      publisherRole: '' as string,
      draftDurationDays: 0 as number | null,
    },
  },
  CUSTOMER_MENU_PLANNING_MISSED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      weekStartDate: '' as string,
      missingCanteenCount: 0 as number,
      missingCanteenIds: [] as string[],
      weeksAheadChecked: 0 as number | undefined,
      isEscalation: false as boolean,
    },
  },
  MENU_DRAFT_SAVED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekId: '' as string,
      weekdayCount: 0 as number,
      dishCountMain: 0 as number,
      dishCountSoup: 0 as number,
      dishCountDessert: 0 as number,
    },
  },
  MENU_SLOT_CONFIGURED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string,
      menuWeekId: '' as string,
      menuSlotId: '' as string,
      weekday: 0 as number,
      daypart: '' as string,
      courseCount: 0 as number,
      menuSlotKey: '' as string,
    },
  },
  MENU_PUBLISHING_FAILED: {
    categories: ['analytics'] as EventCategory[],
    properties: {
      tenantId: '' as string | undefined,
      weekStartDate: '' as string,
      errorMessage: '' as string,
    },
  },
} as const;
